// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.91.0/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.91.0/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.as-searchForm-wrapper {
  --as-searchForm-bg-color: #f7f9fd;
}
.ellipsis {
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}
.as-cardTable-item {
  border-radius: 8px;
  border: 1px solid #dbe0e5;
  box-shadow: 0 0 6px 0 rgba(80, 87, 102, 0.1);
  padding: 12px 12px 0px 12px;
  position: relative;
}
.as-cardTable-item-tag {
  position: absolute;
  right: 0px;
  top: -1px;
  padding: 3px 4px;
  color: white;
  background: #588ce9;
  border-bottom-left-radius: 4px;
  border-top-right-radius: 8px;
  line-height: 1em;
}
.as-cardTable-item-cotent-container {
  overflow: hidden;
  -webkit-flex: 1 1;
          flex: 1 1;
}
.as-cardTable-item-content-ellp {
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}
.as-cardTable-item-ellp .as-cardTable-item-title {
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}
.as-cardTable-item-title {
  width: 100%;
  font-size: 14px;
  font-weight: 800;
  color: #111111;
  line-height: 1.6;
  padding-right: 4px;
  display: -webkit-flex;
  display: flex;
  -webkit-align-items: flex-start;
          align-items: flex-start;
  -webkit-justify-content: space-between;
          justify-content: space-between;
}
.as-cardTable-item-title > span {
  -webkit-flex: 1 1;
          flex: 1 1;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}
.as-cardTable-item-select-icon .wui-checkbox-label {
  padding-left: 14px;
}
.as-cardTable-item-ellp > .as-cardTable-item-title {
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}
.as-cardTable-item-item-content-ellp {
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}
.as-cardTable-item-card-img {
  width: 48px;
  height: 48px;
  margin-right: 12px;
  border-radius: 4px;
}
.as-cardTable-item-borderd {
  border: 1px solid #D1D5DB;
  box-shadow: 0 2px 6px 0 #0000001f;
}
.as-cardTable-item-horizontal {
  display: -webkit-flex;
  display: flex;
}
.as-cardTable-item-info {
  font-size: 12px;
  color: #111111;
  line-height: 1.5;
  font-weight: 500;
  display: -webkit-flex;
  display: flex;
  -webkit-align-items: flex-start;
          align-items: flex-start;
}
.as-cardTable-item-info-label {
  color: #666;
}
.as-cardTable-item-info-value {
  -webkit-flex: 1 1;
          flex: 1 1;
}
.as-cardTable-item:hover {
  border: 1px solid #b0c0d0;
  box-shadow: 0 0 6px 0 rgba(80, 87, 102, 0.15);
}
.as-cardTable-item:hover .hover-footer {
  display: -webkit-flex;
  display: flex ;
}
.as-cardTable-item-footer {
  width: 100%;
  padding: 8px 4px 8px 0px;
  display: -webkit-flex;
  display: flex;
  -webkit-justify-content: flex-end;
          justify-content: flex-end;
}
.as-cardTable-item-hover-footer {
  display: none;
}
.as-cardTable-item-no-hover-footer {
  display: -webkit-flex;
  display: flex;
  border-top: 1px solid #d9d9d9;
  margin-top: 12px;
}
.as-cardTable-item-hover {
  padding-bottom: 12px;
}
.as-cardTable-item-hover:hover {
  padding-bottom: 0px;
}
`, "",{"version":3,"sources":["webpack://./src/assets/style/prefix.less","webpack://./src/assets/style/as-variable.less","webpack://./src/components/DataTable/src/components/CardItem.less"],"names":[],"mappings":"AAAC;ECIC,iCAAA;ACFF;AAAA;EACI,mBAAA;EACA,uBAAA;EACA,gBAAA;AAEJ;AFPC;EEQG,kBAAA;EACA,yBAAA;EACA,4CAAA;EACA,2BAAA;EACA,kBAAA;AAEJ;AADI;EACI,kBAAA;EACA,UAAA;EACA,SAAA;EACA,gBAAA;EACA,YAAA;EACA,mBAAA;EACA,8BAAA;EACA,4BAAA;EACA,gBAAA;AAGR;AADI;EACI,gBAAA;EACA,iBAAA;UAAA,SAAA;AAGR;AAAI;EA1BA,mBAAA;EACA,uBAAA;EACA,gBAAA;AA6BJ;AADK;EA9BD,mBAAA;EACA,uBAAA;EACA,gBAAA;AAkCJ;AAFI;EACI,WAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,gBAAA;EACA,kBAAA;EACA,qBAAA;EAAA,aAAA;EACA,+BAAA;UAAA,uBAAA;EACA,sCAAA;UAAA,8BAAA;AAIR;AAHQ;EACI,iBAAA;UAAA,SAAA;EA7CR,mBAAA;EACA,uBAAA;EACA,gBAAA;AAmDJ;AAHK;EAKO,kBAAA;AACZ;AAII;EA5DA,mBAAA;EACA,uBAAA;EACA,gBAAA;AA2DJ;AAEI;EA/DA,mBAAA;EACA,uBAAA;EACA,gBAAA;AAgEJ;AAAI;EACI,WAAA;EACA,YAAA;EACA,kBAAA;EACA,kBAAA;AAER;AAGI;EACI,yBAAA;EACA,iCAAA;AADR;AAII;EACI,qBAAA;EAAA,aAAA;AAFR;AAII;EACI,eAAA;EACA,cAAA;EACA,gBAAA;EACA,gBAAA;EACA,qBAAA;EAAA,aAAA;EACA,+BAAA;UAAA,uBAAA;AAFR;AAGQ;EACI,WAAA;AADZ;AAGQ;EACI,iBAAA;UAAA,SAAA;AADZ;AAQI;EACI,yBAAA;EACA,6CAAA;AANR;AAII;EAIQ,qBAAA;EAAA,cAAA;AALZ;AAQI;EACI,WAAA;EACA,wBAAA;EACA,qBAAA;EAAA,aAAA;EACA,iCAAA;UAAA,yBAAA;AANR;AAQI;EACI,aAAA;AANR;AAQI;EACI,qBAAA;EAAA,aAAA;EACA,6BAAA;EACA,gBAAA;AANR;AFrHC;EEoIG,oBAAA;AAZJ;AAaI;EACI,mBAAA;AAXR","sourcesContent":["// gpass-appsupport业务组件库样式前缀\n@as-prefix: ~\"as\";\n@template-prefix: 'aiot';\n@as-prefix-cls: ~\"@{as-prefix}-\";\n\n//cardTable样式前缀\n@as-cardTable: ~\"@{as-prefix-cls}cardTable\";\n//dataForm样式前缀\n@as-dataForm: ~\"@{as-prefix-cls}dataForm\";\n\n@as-tableOperation: ~\"@{as-prefix-cls}tableOperation\";\n//dataForm样式前缀\n@as-dataTree: ~\"@{as-prefix-cls}dataTree\";\n// dataTable样式前缀\n@as-dataTable: ~\"@{as-prefix-cls}dataTable\";\n// searchForm样式前缀\n@as-searchForm: ~\"@{as-prefix-cls}searchForm\";\n// editTable样式前缀\n@as-editTable: ~\"@{as-prefix-cls}table-edit\";\n@as-editTablePro: ~\"@{as-prefix-cls}table-edit-pro\";\n// SwitchButton样式前缀\n@as-switchButton: ~\"@{as-prefix-cls}switchButton\";\n// 树参照样式前缀\n@as-referTree: ~\"@{as-prefix-cls}referTree\";\n// 表参照样式前缀\n@as-referTable: ~\"@{as-prefix-cls}referTable\";\n// 树表参照样式前缀\n@as-referTreeTable: ~\"@{as-prefix-cls}referTreeTable\";\n","@import \"./prefix.less\";\n@import \"./public.less\";\n\n.@{as-searchForm}-wrapper {\n  --@{as-searchForm}-bg-color: #f7f9fd;\n}\n\n","@import \"../../../../assets/style/as-variable.less\";\n\n.ellipsis{\n    white-space: nowrap;\n    text-overflow: ellipsis;\n    overflow: hidden;\n}\n.@{as-cardTable}-item{\n    border-radius: 8px;\n    border:1px solid #dbe0e5;\n    box-shadow: 0 0 6px 0 rgba(80,87,102,0.1);\n    padding: 12px 12px 0px 12px;\n    position: relative;\n    &-tag{\n        position: absolute;\n        right: 0px;\n        top: -1px;\n        padding: 3px 4px;\n        color: white;\n        background: #588ce9;\n        border-bottom-left-radius: 4px;\n        border-top-right-radius: 8px;\n        line-height: 1em;\n    }\n    &-cotent-container{\n        overflow: hidden;\n        flex: 1;\n        \n    }\n    &-content-ellp{\n        .ellipsis();\n       \n    }\n     &-ellp &-title{\n        .ellipsis();\n    }\n   \n    &-title{\n        width: 100%;\n        font-size: 14px;\n        font-weight: 800;\n        color: #111111;\n        line-height: 1.6;\n        padding-right: 4px;\n        display: flex;\n        align-items: flex-start;\n        justify-content: space-between;\n        &>span{\n            flex:1;\n            .ellipsis()\n        }\n    }\n\n     &-select-icon{\n        // position: absolute;\n        // top: 15px;\n        // right: 16px;\n        .wui-checkbox-label{\n            padding-left: 14px;\n        }\n\n    }\n    \n    &-ellp > &-title{\n        .ellipsis()\n    }\n    &-item-content-ellp{\n        .ellipsis()\n    }\n    &-card-img{\n        width: 48px;\n        height: 48px;\n        margin-right: 12px;\n        border-radius: 4px;\n    }\n    //.vertical{\n    //    display: flex;\n    //}\n    &-borderd{\n        border: 1px solid #D1D5DB;\n        box-shadow: 0 2px 6px 0 #0000001f;\n    }\n\n    &-horizontal{\n        display: flex;\n    }\n    &-info{\n        font-size: 12px;\n        color: #111111;\n        line-height: 1.5;\n        font-weight: 500;\n        display: flex;\n        align-items: flex-start;\n        &-label{\n            color: #666;\n        }\n        &-value{\n            flex:1;\n        }\n    }\n\n\n\n\n    &:hover{\n        border:1px solid #b0c0d0;\n        box-shadow: 0 0 6px 0 rgba(80,87,102,0.15);\n        .hover-footer{\n            display:flex ;\n        }\n    }\n    &-footer{\n        width: 100%;\n        padding: 8px 4px 8px 0px;\n        display: flex;\n        justify-content: flex-end;\n    }\n    &-hover-footer{\n        display:none;\n    }\n    &-no-hover-footer{\n        display: flex;\n        border-top: 1px solid #d9d9d9;\n        margin-top: 12px;\n    }\n\n\n\n\n}\n\n.@{as-cardTable}-item-hover{\n    padding-bottom: 12px;\n    &:hover{\n        padding-bottom: 0px;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
